<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <div v-if="strategy" :style="{ borderTop: '6px solid ' + strategyColor }" class="fin-strategy-details pt-9">

        <Portal :to="isShareStrategy ? 'breadcrumb_finStrategy_details' : 'breadcrumb_finStrategy_etfdetails'">
          {{ strategy.name }}
        </Portal>

        <div v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
             v-style:paddingRight="$valueByBreakpoint($finPadding.right)">

          <v-btn v-if="portfolioId && mode !== 'chooseStrategy'"
                 class="ml-3"
                 dark
                 style="float: right"
                 @click="goToPortfolio">
            Zurück zum Portfolio
          </v-btn>
          <v-btn v-if="portfolioId && mode === 'chooseStrategy'"
                 dark
                 style="float: right"
                 @click="chooseStrategy">
            Anwenden
          </v-btn>

          <p v-if="strategy.category" class="subheader mb-2">{{ strategy.category.name.toUpperCase() }}</p>
          <h1 :class="`d-inline-flex ${$vuetify.breakpoint.xs ? 'mb-4' : 'mb-9'}`">{{ strategy.name }}</h1>
          <fin-realtime-indicator class="realtime" trading-platform="tradegate"/>
        </div>

        <fin-strategy-details-tabs v-if="isShareStrategy"
                                   :overview-only="overviewOnly"
                                   :strategy="strategy"
                                   :strategy-color="strategyColor"/>

        <fin-strategy-etf-details v-if="isEtfStrategy"
                                  :overview-only="overviewOnly"
                                  :strategy="strategy"/>


      </div>
    </template>
  </fin-data-loader>
</template>

<script>
import FinStrategyDetailsTabs from "@/components/pages/finStrategy/details"
import {etfStrategyDetailsById, shareStrategyDetailsById} from '@/js/finQueries'
import {API, graphqlOperation} from '@/plugins/finAmplifyModules'
import {finPortfolioAPI} from '@/js/finAPI'
import FinStrategyEtfDetails from "@/components/pages/finStrategy/etfDetails/finStrategyEtfDetails"
import FinDataLoader from "@/components/common/DataLoader"
import FinRealtimeIndicator from "@/components/common/RealtimeIndicator"

export default {
  name: 'finStrategyDetails',
  components: {FinRealtimeIndicator, FinDataLoader, FinStrategyEtfDetails, FinStrategyDetailsTabs},
  props: {
    /* set via router props */
    stratId: {
      type: String
    },
    assetClassID: {
      type: String
    },
    portfolioId: {
      type: String
    },
    mode: {
      type: String
    },
    goThenToPage: {
      type: String
    },
    /* end of set via router props */
    /** Only display the first part of the strategy details page. Needed because of onboarding */
    overviewOnly: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      strategy: undefined,
      isShareStrategy: false,
      isEtfStrategy: false,
    }
  },
  computed: {
    strategyColor() {
      return this.$finStrategyColors.find(sc => sc.type === this.strategy.category.id)?.color || 'transparent'
    }
  },
  methods: {
    async loadData() {
      this.isShareStrategy = this.$route.path.includes('/list/shares') || this.assetClassID === 'SHARE'
      this.isEtfStrategy = this.$route.path.includes('/list/etfs') || this.assetClassID?.includes('ETF')

      let result = null
      if (this.isShareStrategy) {
        result = await API.graphql(graphqlOperation(shareStrategyDetailsById, {id: this.stratId.toUpperCase()}))
        this.strategy = result.data.getShareStrategyModel
      } else if (this.isEtfStrategy) {
        result = await API.graphql(graphqlOperation(etfStrategyDetailsById, {id: this.stratId.toUpperCase()}))
        this.strategy = result.data.getEtfStrategyModel
      }
    },
    goToPortfolio() {
      // bring user back to calling page (portfoliodetails for portfolio with portfolioId and calling tab)
      const goTo = {
        name: this.goThenToPage,
        params: {
          id: this.goThenToPage === 'portfolioDetail' ? this.portfolioId : '',
          tab: this.assetClassID
        }
      }
      this.$router.push(goTo)
    },
    async chooseStrategy() {
      const stratId = this.stratId.toUpperCase()

      if (this.portfolioId) {
        try {
          // save this strategy into the portfolio for this asset class
          if (this.assetClassID === 'SHARE') {
            await finPortfolioAPI.updateSharePortfolioStrategy(this.portfolioId, stratId)
          } else if (this.$route.params.assetClassID === 'SHARE_ETF') {
            await finPortfolioAPI.updateShareETFPortfolioStrategy(this.portfolioId, stratId)
          } else if (this.$route.params.assetClassID === 'CORPORATE_BONDS_ETF') {
            await finPortfolioAPI.updateCorporateBondsETFPortfolioStrategy(this.portfolioId, stratId)
          } else if (this.$route.params.assetClassID === 'GOVERNMENT_BONDS_ETF') {
            await finPortfolioAPI.updateGovernmentBondsETFPortfolioStrategy(this.portfolioId, stratId)
          } else if (this.$route.params.assetClassID === 'COMMODITIES_ETF') {
            await finPortfolioAPI.updateCommoditiesETFPortfolioStrategy(this.portfolioId, stratId)
          }
          this.$toasted.global.finToast({
            message: 'Deine Strategie wurde erfolgreich geändert.',
            type: 'success'
          })
        } catch (e) {
          console.error("chooseStrategy: an error occured", e)
          this.$toasted.global.finToast({
            message: 'Deine Strategie konnte nicht erfolgreich geändert werden.',
            type: 'error'
          })
        }
      }

      this.goToPortfolio()
    }
  },
}
</script>

<style lang="scss" scoped>
@import "./../../../styles/variables.scss";

.realtime {
  position: relative !important;
  top: -7px !important;
  left: 5px !important;
}

.fin-strategy-details {
  background-color: $fin-color-primary-light;
}

.subheader {
  font-family: $body-font-family;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: 1px;
  color: $fin-color-cool-grey;
}
</style>
